export default function Text({ children }) {
  return <p className="">{children}</p>
}
